import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  holdToken: null,
  seats: [],
  openCheckout: false,
  totalPrice: 0,
};

export const PromotionType = {
  ONE_PLUS_ONE: 'ONE_PLUS_ONE',
  THREE_PLUS_ONE: 'THREE_PLUS_ONE',
  NONE: '',
};

const cartSlice = createSlice({
  name: 'cart',
  initialState: initialState,
  reducers: {
    addSeat: (state, action) => {
      const { promotionType } = action.payload;
      if (promotionType !== PromotionType.NONE) {
        let seat = { isFree: false, ...action.payload };
        const { promotionType } = seat;

        const divider = promotionType === PromotionType.ONE_PLUS_ONE ? 2 : 4;

        const sameCategoryCount =
          state.seats.filter(
            ({ eventId, categoryId, typeId }) =>
              eventId === seat.eventId && categoryId === seat.categoryId && typeId === seat.typeId
          ).length + 1;
        if (sameCategoryCount % divider === 0) {
          seat.isFree = true;
        }

        state.seats.push(seat);
        if (!seat.isFree) {
          state.totalPrice += seat.price;
        }
      } else {
        let seat = { isFree: false, ...action.payload };

        state.seats.push(seat);
        state.totalPrice += seat.price;
      }
    },

    removeSeat: (state, action) => {
      const { id: idToRemove, typeId: typeIdToRemove, eventId: eventIdToRemove, promotionType } = action.payload;

      const findFunc = typeIdToRemove
        ? ({ eventId, id, typeId }) =>
            idToRemove === id && typeIdToRemove === String(typeId) && eventIdToRemove === eventId
        : ({ eventId, id }) => idToRemove === id && eventIdToRemove === eventId;

      if (promotionType !== PromotionType.NONE) {
        const idx = state.seats.findIndex(findFunc);
        if (idx !== -1) {
          const eventTotalPrice = state.seats
            .filter((s) => s.eventId === eventIdToRemove)
            .reduce((acc, s) => (!s.isFree ? s.price : 0) + acc, 0);

          state.seats.splice(idx, 1);
          state.totalPrice -= eventTotalPrice;

          const objCats = state.seats
            .map(({ eventId, categoryId, typeId }) => `${eventId}-${categoryId}-${typeId}`)
            .reduce((acc, value) => ({ ...acc, [value]: 0 }), {});

          const divider = promotionType === PromotionType.ONE_PLUS_ONE ? 2 : 4;

          for (let i = 0; i < state.seats.length; i++) {
            if (state.seats[i].eventId === eventIdToRemove) {
              const catAndTypeId = `${state.seats[i].eventId}-${state.seats[i].categoryId}-${state.seats[i].typeId}`;
              objCats[catAndTypeId]++;
              if (objCats[catAndTypeId] % divider === 0) {
                state.seats[i].isFree = true;
              } else {
                state.seats[i].isFree = false;
                state.totalPrice += state.seats[i].price;
              }
            }
          }
        }
      } else {
        const idx = state.seats.findIndex(findFunc);

        if (idx !== -1) {
          state.totalPrice -= state.seats[idx].price;
          state.seats.splice(idx, 1);
        }
      }
    },

    clearSeats: (state) => {
      state.seats = [];
      state.totalPrice = 0;
    },

    setHoldToken: (state, action) => {
      state.holdToken = action.payload;
    },

    clearHoldToken: (state, action) => {
      state.holdToken = null;
    },

    setOpenCheckout: (state, action) => {
      state.openCheckout = action.payload;
    },
  },
});

export const { addSeat, removeSeat, clearSeats, setHoldToken, clearHoldToken, setOpenCheckout } = cartSlice.actions;

export default cartSlice.reducer;
